<template>
  <div>
    <div class="px-5 sm:px-20 mt-10 pt-5" :class="{ '!p-0 !mt-0': isModal }">
      <div
        class="grid grid-cols-12 gap-4 gap-y-5 mt-5"
        data-test="problem-form"
      >
        <div class="font-medium text-base col-span-12">สภาพปัญหา</div>
        <div class="col-span-12">
          <div
            :id="`problem-accordion-${key}`"
            class="accordion accordion-boxed"
            :class="{ 'mt-5': key > 0 }"
            v-for="(data, key) in data_problem"
            :key="key"
          >
            <div class="accordion-item">
              <div
                :id="`problem-accordion-content-${key}`"
                class="accordion-header"
              >
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="`#problem-accordion-collapse-${key}`"
                  aria-expanded="true"
                  :aria-controls="`problem-accordion-collapse-${key}`"
                >
                  {{ data.desc }}
                </button>
              </div>
              <div
                :id="`problem-accordion-collapse-${key}`"
                class="accordion-collapse collapse show"
                :aria-labelledby="`problem-accordion-content-${key}`"
                :data-bs-parent="`#problem-accordion-${key}`"
              >
                <div
                  class="
                    accordion-body
                    text-gray-700
                    dark:text-gray-600
                    leading-relaxed
                    gap-4 gap-y-5
                    grid grid-cols-12
                    ml-6
                    items-baseline
                  "
                >
                  <div
                    class="col-span-12 sm:col-span-6 grid"
                    v-for="(choice, key2) in data.choices"
                    :key="key2"
                    v-show="!choice.option?.noDisplay"
                  >
                    <div class="form-checkbox-custom pl-6 sm:flex">
                      <div class="mr-3">
                        <label
                          class="form-check-label align-middle"
                          :for="`form-input-problem-${choice.option.code}`"
                        >
                          <input
                            :id="`form-input-problem-${choice.option.code}`"
                            class="form-check-input align-middle"
                            type="checkbox"
                            :value="choice.option"
                            v-model="form.problemObj[data.name]"
                            @change="checkedChange"
                          />{{ choice.option.desc }}
                        </label>
                      </div>
                      <div
                        class="form-input-for-checkbox"
                        v-if="
                          choice.specify &&
                            form.problemObj[data.name].some(
                              ({ code }) => code == choice.option.code
                            )
                        "
                      >
                        <input
                          type="text"
                          class="form-control"
                          placeholder="กรุณาระบุ"
                          data-test="problem-choice"
                          v-model="
                            form.problemObj[data.name][
                              form.problemObj[data.name].findIndex(
                                (p) => p.code == choice.option.code
                              )
                            ].name
                          "
                          @input="
                            (inputEvent) =>
                              updateUserTextInput(
                                inputEvent,
                                choice.option.code
                              )
                          "
                          :class="{
                            'border-1 border-theme-24 rounded-md':
                              validate.problemObj[data.name].$each.$response
                                .$errors[
                                form.problemObj[data.name].findIndex(
                                  (p) => p.code == choice.option.code
                                )
                              ].name.length,
                          }"
                        />
                        <template
                          v-if="
                            validate.problemObj[data.name].$each.$response
                              .$errors[
                              form.problemObj[data.name].findIndex(
                                (p) => p.code == choice.option.code
                              )
                            ].name.length
                          "
                        >
                          <div
                            v-for="(error, index) in validate.problemObj[
                              data.name
                            ].$each.$response.$errors[
                              form.problemObj[data.name].findIndex(
                                (p) => p.code == choice.option.code
                              )
                            ].name"
                            :key="index"
                            class="text-theme-24 mt-1 text-xs"
                          >
                            {{ error.$message }}
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="col-span-12 mt-10" />
    </div>
    <div
      id="sent-to-csg-modal"
      class="modal"
      tabindex="-1"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog">
        <div class="modal-content bg-theme-39">
          <a
            data-dismiss="modal"
            href="javascript:;"
            class="absolute right-4 top-3 text-gray-500"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-x w-8 h-8 text-gray-500 w-8 h-8 text-gray-500"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line></svg
          ></a>
          <div class="modal-header">
            <h3 class="text-theme-1 font-semibold text-md">
              ยืนยันบันทึก และส่งข้อมูล
            </h3>
          </div>
          <div class="modal-body p-6">
            <div class="bg-white rounded-md p-4">
              <div class="flex-1">
                <div class="space-y-2">
                  <div class="form-checkbox-custom pl-6">
                    <label for="system-CSG-4" class="form-label cursor-pointer"
                      >บันทึก และส่งข้อมูลไปที่
                      ระบบเงินอุดหนุนเพื่อการเลี้ยงดูเด็กแรกเกิด
                      กรมกิจการเด็กและเยาวชน (CSG)
                    </label>
                    <label
                      for="system-CSG-4"
                      class="mt-2 text-theme-1 font-semibold form-label cursor-pointer"
                      >เลือกสถานะเด็ก
                    </label>

                    <div style="">
                      <div
                        class="flex flex-col space-y-2 mt-2 max-w-xs mx-auto"
                      >
                        <!-- <div class="flex items-center">
                          <input
                            id="form-input-kid-status-1"
                            class="align-middle"
                            type="radio"
                            name="form-input-kid-status"
                            value="เด็กเสียชีวิต"
                            style=""
                          />
                          <label
                            class="align-middle ml-2"
                            for="form-input-kid-status-1"
                            >เด็กเสียชีวิต</label
                          >
                        </div> -->
<div class="flex items-center">
                          <input
                            id="form-input-kid-status-1"
                            class="align-middle"
                            type="radio"
                            name="form-input-kid-status"
                            value="-"
                            style=""
                          />
                          <label
                            class="align-middle ml-2"
                            for="form-input-kid-status-1"
                            >ไม่ระบุ</label
                          >
                        </div>
                        <div class="flex items-center">
                          <input
                            id="form-input-kid-status-2"
                            class="align-middle"
                            type="radio"
                            name="form-input-kid-status"
                            value="เด็กไม่อยู่ในพื้นที่"
                          />
                          <label
                            class="align-middle ml-2"
                            for="form-input-kid-status-2"
                            >เด็กไม่อยู่ในพื้นที่</label
                          >
                        </div>

                        <div class="flex items-center">
                          <input
                            id="form-input-kid-status-3"
                            class="align-middle"
                            type="radio"
                            name="form-input-kid-status"
                            value="เด็กและผู้ปกครองไม่อยู่ในพื้นที่"
                          />
                          <label
                            class="align-middle ml-2"
                            for="form-input-kid-status-3"
                            >เด็กและผู้ปกครองไม่อยู่ในพื้นที่</label
                          >
                        </div>

                        <div class="flex items-center">
                          <input
                            id="form-input-kid-status-4"
                            class="align-middle"
                            type="radio"
                            name="form-input-kid-status"
                            value="เด็กอยู่สถานสงเคราะห์"
                          />
                          <label
                            class="align-middle ml-2"
                            for="form-input-kid-status-4"
                            >เด็กอยู่สถานสงเคราะห์</label
                          >
                        </div>

                        <div class="flex items-center">
                          <input
                            id="form-input-kid-status-5"
                            class="align-middle"
                            type="radio"
                            name="form-input-kid-status"
                            value="ไม่ประสงค์รับบริการ"
                          />
                          <label
                            class="align-middle ml-2"
                            for="form-input-kid-status-5"
                            >ไม่ประสงค์รับบริการ</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="col-span-12 mt-4" />
              <!-- footer -->
              <div class="col-span-12 flex items-center mt-4 justify-end">
                <button class="btn btn-secondary ml-2" data-dismiss="modal">
                  ยกเลิก</button
                ><button class="btn btn-primary ml-2" @click="completeForm('close')" data-dismiss="modal">
          บันทึก
        </button><button
                  class="btn btn-primary ml-2"
                  @click="completeForm('CSG')"
                  data-dismiss="modal"
                >
                  บันทึก และส่งข้อมูล
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-span-12 flex items-center mt-10 justify-end" v-if="isModal">
      <div>
        <button
          class="btn btn-outline-secondary"
          data-dismiss="modal"
          @click="cancelModalButton"
        >
          ยกเลิก
        </button>
        <button class="btn btn-primary ml-2" @click="completeForm">
          บันทึก
        </button>
      </div>
    </div>
    <div
      class="col-span-12 flex items-center mt-10 px-5 sm:px-20 justify-between"
      v-else
    >
      <div>
        <button class="btn btn-secondary" @click="closeWizardForm">ออก</button>
      </div>
      <div>
        <button class="btn btn-secondary ml-2" @click="prevStep">
          ย้อนกลับ
        </button>
        <button class="btn btn-primary ml-2" @click="completeForm">
          บันทึก
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, defineComponent, ref, toRefs, watch, computed } from "vue";
import dataJson from "@/data/problem.json";
import { useRouter, useRoute } from "vue-router";
import Swal from "sweetalert2";
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import { useStore } from "vuex";
import axios from "axios";
import dim_prob from "@/data/dim_prob.json";
import $ from "jquery";
import { getAllowActionByCurrRole } from "@/utils/get-roles";

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
  },
  buttonsStyling: false,
});
export default defineComponent({
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    updateId: {
      type: String,
    },
    editData: {
      type: Object, // response from getMemberSurveyById
    },
    cancelModal: {
      type: Boolean,
      default: false,
    },
    openModal: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const data_problem = reactive(dataJson.problem);
    const problemNames = new Set(data_problem.map((problem) => problem.name)); // All problems' names in problem.json
    // Ex. Set ["prob_housing", "prob_health", ..., "prob_others"]
    const dimProblemNames = new Set(
      dim_prob.map((dimProblem) => dimProblem.dim_code)
    ); // All dim_code in dim_prob.json
    // Ex. Set ["prob_accesibility", "prob_education", ..., "prob_occupation"]
    const mapCodeToOptionAndDesc = new Map(
      data_problem
        .map((problem) => problem.choices)
        .flat()
        .map((option) => {
          const desc =
            option.specify && option.option.name
              ? `${option.option.desc} (${option.option.name})`
              : option.option.desc;

          return [
            option.option.code,
            {
              option: option.option,
              desc: desc,
            },
          ];
        })
    ); // Map [problem code, {"option": problem object, "desc": problem description}]
    // Ex. Map {'PBHO1' => ["option": {"code": "PBHO1", "desc": "ไม่มีกรรมสิทธิ์ในที่อยู่อาศัย"}, 'ไม่มีกรรมสิทธิ์ในที่อยู่อาศัย'],
    //          'PBOC15' => ["option": {"code": "PBOC15", "desc": "อื่นๆ", "name": "user input"}, 'อื่นๆ (user input)'], ...

    const formDefault = reactive({
      problemObj: {},
      prob_summary: {},
      tempProbSummary: {},
    });
    for (const key of problemNames) {
      formDefault.problemObj[key] = [];
    }
    for (const key of dimProblemNames) {
      formDefault.prob_summary[key] = [];
      formDefault.tempProbSummary[key] = [];
    }

    const form = reactive(structuredClone(formDefault));

    const currStep = ref(5);
    const router = useRouter();
    const route = useRoute();
    const rules = {
      problemObj: {
        prob_occupation: {
          $each: helpers.forEach({
            name: {
              required: helpers.withMessage(`กรุณาระบุ`, required),
            },
          }),
        },
      },
    };
    const validate = useVuelidate(rules, toRefs(form));
    const store = useStore();
    const token = store.getters["userAuth/getToken"];
    const externalSystem = computed(() => store.state.main.externalSystem);
    let promises = [];
    const checkAgeLTE5Y11M = (formBirthdate) => {
      const birthDate = new Date(formBirthdate);

      const today = new Date();
      const cutoffDate = new Date(birthDate);
      cutoffDate.setFullYear(birthDate.getFullYear() + 6);
      cutoffDate.setDate(cutoffDate.getDate() - 1);

      return today <= cutoffDate;
    };
    const showAlert = (text, icon, action, modalId) => {
    swalCustom
        .fire({
            text: text,
            icon: icon,
            timer: 4000,
            confirmButtonText: "ปิด",
        })
        .then(() => {
            if (action === 'modal_hide') {
                cash(modalId).modal("hide");
                emit("update-state");
            } else if (action === 'router_replace') {
                router.replace({
                    name: "family-profile",
                    id: route.params.famid,
                });
            }
        });
};
    async function completeForm(check_sent_to_other_system) {
      if (props.openModal) {
        await dealWithUncheckedChoices();
      }
      validate.value.$touch();
      if (validate.value.$invalid) {
        return;
      }
      let newMapProbSummary = JSON.parse(JSON.stringify(form.prob_summary));
      Object.keys(newMapProbSummary).forEach((element) => {
        if (newMapProbSummary[element].length < 1)
          delete newMapProbSummary[element];
      });
let _update = {
            prob_housing:
              form.problemObj.prob_housing?.length > 0
                ? form.problemObj.prob_housing.map(({ category, ...rest }) => ({
                    ...rest,
                  }))
                : null,
            prob_health:
              form.problemObj.prob_health?.length > 0
                ? form.problemObj.prob_health.map(({ category, ...rest }) => ({
                    ...rest,
                  }))
                : null,
            prob_education:
              form.problemObj.prob_education?.length > 0
                ? form.problemObj.prob_education.map(
                    ({ category, ...rest }) => ({ ...rest })
                  )
                : null,
            prob_occupation:
              form.problemObj.prob_occupation?.length > 0
                ? form.problemObj.prob_occupation.map(
                    ({ category, ...rest }) => ({ ...rest })
                  )
                : null,
            prob_family:
              form.problemObj.prob_family?.length > 0
                ? form.problemObj.prob_family.map(({ category, ...rest }) => ({
                    ...rest,
                  }))
                : null,
            prob_violence:
              form.problemObj.prob_violence?.length > 0
                ? form.problemObj.prob_violence.map(
                    ({ category, ...rest }) => ({ ...rest })
                  )
                : null,
            prob_human_trafficking:
              form.problemObj.prob_human_trafficking?.length > 0
                ? form.problemObj.prob_human_trafficking.map(
                    ({ category, ...rest }) => ({ ...rest })
                  )
                : null,
            prob_accesibility:
              form.problemObj.prob_accesibility?.length > 0
                ? form.problemObj.prob_accesibility.map(
                    ({ category, ...rest }) => ({ ...rest })
                  )
                : null,
            prob_others:
              form.problemObj.prob_others?.length > 0
                ? form.problemObj.prob_others.map(({ category, ...rest }) => ({
                    ...rest,
                  }))
                : null,
            prob_summary:
              Object.keys(newMapProbSummary)?.length > 0
                ? newMapProbSummary
                : null,
          }
    if(externalSystem.value == "CSG"){
_update.linking_system = [{system: "CSG", updated_at: new Date().toISOString().split('T')[0]}];
}else if(externalSystem.value == "BORA"){
_update.linking_system = [{system: "BORA", updated_at: new Date().toISOString().split('T')[0]}];
}
      const config = {
        url: `${process.env.VUE_APP_BASE_API}member/${
          props.isModal ? props.editData._id : props.updateId
        }`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": `application/json; charset=utf-8`,
        },
        data: {
          update: _update
        },
      };
      let form_all = null;
      let check_csg = false;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": `application/json; charset=utf-8`,
      };
      try {
        const url = `${process.env.VUE_APP_BASE_API}member/getMemberSurveyById`;
        const response = await axios.post(
          url,
          {
            memberId: `${props.isModal ? props.editData._id : props.updateId}`,
          },
          { headers }
        );
        form_all = response.data;
      } catch (error) {
        // จัดการเมื่อดึงข้อมูลสมาชิกไม่สำเร็จ
        console.error("Error fetching member survey data:", error);
        swalCustom.fire({
          icon: "warning",
          text:
            "ไม่สามารถดึงข้อมูลสมาชิกเพื่อส่งต่อไปยังระบบ CSG ได้ โปรดลองอีกครั้ง",
        });
        return; // หยุดการทำงานของ completeForm
      }
      console.log("form_all");
      console.log(form_all);
      let kidStatus = null;
       const selectedRadio = cash(
          'input[name="form-input-kid-status"]:checked'
        );
        if (selectedRadio.length > 0) {
          kidStatus = selectedRadio.val();
        }
        let example_sent_to_csg = {
          "general_info": {
            hh_id: form_all.hh_id || null,
            fam_id: form_all.fam_id || null,
            hnum: form_all.hnum || null,
            village_code: form_all.village_code || null,
            village_name: form_all.village_name || null,
            moo: form_all.moo || null,
            soi: form_all.soi || null,
            road: form_all.road || null,
            tumbol_code: form_all.tumbol_code || null,
            tumbol_name: form_all.tumbol_name || null,
            amphur_code: form_all.amphur_code || null,
            amphur_name: form_all.amphur_name || null,
            province_code: form_all.province_code || null,
            province_name: form_all.province_name || null,
            postcode: form_all.postcode || null,
            mso_osm: form_all.mso_osm || null,
            title: form_all.title || null,
            name: form_all.name || null,
            surname: form_all.surname || null,
            national_id: form_all.national_id || null,
            mobile_num: form_all.mobile_num || null,
            birthdate: form_all.birthdate || null,
            sex: form_all.sex || null,
            marital_status: form_all.marital_status || null,
            nationality: form_all.nationality || null,
            nationality_other: form_all.nationality_other || null,
            religion: form_all.religion || null,
            vital_status: form_all.vital_status || null,
            edu_status: form_all.edu_status || null,
            edu_level: form_all.edu_level || null,
            attend_socact: form_all.attend_socact || null,
            father: form_all.father || null,
            mother: form_all.mother || null,
            status: form_all.status || null,
            modified_by: store.getters["userInfo/getUserInfoForApi"],
            msoid: form_all.msoid || null,
          },
          disability: form_all.disability || null,
          member_cnt: null,
          sum_income: null,
          csg_status: kidStatus || null,
        };
      let isEligibleForCSG = false
      // if (isEligibleForCSG && check_sent_to_other_system !== "CSG" && check_sent_to_other_system != 'close' && route.params.famid) {
      //   cash("#sent-to-csg-modal").modal("show");
      //   return;
      // }
       try {
        let response = null;
        if(form_all.nationality == "ไทย" &&
        checkAgeLTE5Y11M(form_all.birthdate) && route.params.famid){
         const url_family = `${process.env.VUE_APP_BASE_API}family/getFamilySurveyById`;
    
    response = await axios.post(
        url_family, 
        { famId: route.params.famid }, 
        { headers }
    );
    
    const res = response.data; 
    example_sent_to_csg.member_cnt = res?.memberinfo?.member_cnt ?? null;
    example_sent_to_csg.sum_income = res?.memberinfo?.sum_income ?? null;
    
    isEligibleForCSG =
        externalSystem.value != "CSG" &&
        form_all.nationality == "ไทย" &&
        checkAgeLTE5Y11M(form_all.birthdate) &&
        (example_sent_to_csg.sum_income * 12) / example_sent_to_csg.member_cnt <= 100000;

        }
    if (isEligibleForCSG && check_sent_to_other_system !== "CSG" && check_sent_to_other_system != 'close' && route.params.famid) {
        cash("#sent-to-csg-modal").modal("show");
        return;
    }
      } catch (error) {
         console.error("Error fetching family data:", error);
      }

      promises = []; // รีเซ็ต promises
      promises.push(axios(config));
      if (isEligibleForCSG && check_sent_to_other_system != 'close' && route.params.famid) {
        check_csg = true;
      }
      // ถ้ามีการกดปุ่ม "บันทึกและส่งข้อมูล" จาก Modal (check_sent_to_other_system == 'CSG')
      if (isEligibleForCSG && check_sent_to_other_system === "CSG" && route.params.famid) {
        check_csg = true;

        const config = {
          url: `${process.env.VUE_APP_BASE_API}member/${
            props.isModal ? props.editData._id : props.updateId
          }`,
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": `application/json; charset=utf-8`,
          },
          data: {
            update: { csg:{status: kidStatus} },
          },
        };
        const url_kidStatus = `${process.env.VUE_APP_BASE_API}member/${
            props.isModal ? props.editData._id : props.updateId
          }`;
        const fetchkidStatus = axios
          .put(url_kidStatus, { update: { csg:{status: kidStatus}} }, { headers })
          .then((response) => {
          })
          .catch((error) => {
            console.error("Error fetching family data:", error);
            return Promise.reject(error);
          });
        const apiConfigCSG = fetchkidStatus.then(() => ({
          url: `${process.env.VUE_APP_BASE_API}dc/send2Ext`,
          method: "POST",
          headers: headers,
          data: {
      target_system: "csg",
      payload: example_sent_to_csg
    }
        }));
        promises.push(apiConfigCSG.then((config) => axios(config)));

        if (selectedRadio.length > 0) {
    selectedRadio.prop('checked', false); 
}
      }
      if (props.isModal) {
        if (check_csg) {
        Promise.all(promises.map((p) => p.catch((e) => e)))
            .then((results) => {
                const csgResult = results[results.length - 1]; 
                const csgSendFailed = csgResult instanceof Error;
                
                let alertText = "บันทึกข้อมูลสำเร็จ";
                let alertIcon = "success";
                
                if (csgSendFailed) {
                    alertText = "บันทึกข้อมูลสำเร็จ แต่ส่งไปยัง CSG ไม่สำเร็จ";
                    alertIcon = "warning";
                }
                showAlert(alertText, alertIcon, 'modal_hide', "#edit-member-modal");
            })
            .catch((error) => {
                showAlert("ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง", "warning", 'none', null);
                console.error("Error before Promise.all execution:", error);
            });
        return;
    }
        // if (check_csg) {
        //   Promise.all(promises.map((p) => p.catch((e) => e))) // ยอมให้ error ผ่านไปได้
        //     .then((results) => {
        //       const hasError = results.some((r) => r instanceof Error);

        //       if (hasError) {
        //         swalCustom
        //           .fire({
        //             text: "สำเร็จ",
        //             icon: "success",
        //             timer: 3000,
        //             confirmButtonText: "ปิด",
        //           })
        //           .then(() => {
        //             cash("#edit-member-modal").modal("hide");
        //             emit("update-state");
        //           });
        //         //  swalCustom.fire({
        //         //     text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
        //         //     icon: "warning",
        //         //     confirmButtonText: "ปิด",
        //         // });
        //       } else {
        //         swalCustom
        //           .fire({
        //             text: "สำเร็จ",
        //             icon: "success",
        //             timer: 3000,
        //             confirmButtonText: "ปิด",
        //           })
        //           .then(() => {
        //             cash("#edit-member-modal").modal("hide");
        //             emit("update-state");
        //           });
        //       }
        //     })
        //     .catch((error) => {
        //       swalCustom
        //         .fire({
        //           text: "สำเร็จ",
        //           icon: "success",
        //           timer: 3000,
        //           confirmButtonText: "ปิด",
        //         })
        //         .then(() => {
        //           cash("#edit-member-modal").modal("hide");
        //           emit("update-state");
        //         });
        //       // // Error ที่เกิดก่อน Promise.all ถูกเรียก
        //       // swalCustom.fire({
        //       //   text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
        //       //   icon: "warning",
        //       //   confirmButtonText: "ปิด",
        //       // });
        //       // console.log(error);
        //     });
        //   return;
        // }
        swalCustom
          .fire({
            text: "ยืนยันบันทึกข้อมูล",
            icon: "info",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก",
          })
          .then((result) => {
            if (result.isConfirmed) {
              // 🔑 ใช้ Promise.all เพื่อรอ API ทั้งหมด
              Promise.all(promises.map((p) => p.catch((e) => e))) // ยอมให้ error ผ่านไปได้
                .then((results) => {
                  const hasError = results.some((r) => r instanceof Error);

                  if (hasError) {
                     swalCustom.fire({
                        text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                        icon: "warning",
                        confirmButtonText: "ปิด",
                    });
                  } else {
                    swalCustom
                      .fire({
                        text: "สำเร็จ",
                        icon: "success",
                        timer: 3000,
                        confirmButtonText: "ปิด",
                      })
                      .then(() => {
                        cash("#edit-member-modal").modal("hide");
                        emit("update-state");
                      });
                  }
                })
                .catch((error) => {
                  // Error ที่เกิดก่อน Promise.all ถูกเรียก
                  swalCustom.fire({
                    text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                    icon: "warning",
                    confirmButtonText: "ปิด",
                  });
                  console.log(error);
                });
            }
          });
      } else {
        // ไม่ใช่ Modal (สำหรับ Wizard Form)
        if (check_csg) {
        Promise.all(promises.map((p) => p.catch((e) => e)))
            .then((results) => {
                const csgResult = results[results.length - 1]; 
                const csgSendFailed = csgResult instanceof Error;
                
                let alertText = "บันทึกข้อมูลสำเร็จ";
                let alertIcon = "success";
                
                if (csgSendFailed) {
                    alertText = "บันทึกข้อมูลสำเร็จ แต่ส่งไปยัง CSG ไม่สำเร็จ";
                    alertIcon = "warning";
                }

                showAlert(alertText, alertIcon, 'router_replace', null);
            })
            .catch((error) => {
                showAlert("ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง", "warning", 'router_replace', null);
                console.error("Error before Promise.all execution:", error);
            });
        return;
        }
        swalCustom
          .fire({
            text: "ยืนยันบันทึกข้อมูล",
            icon: "info",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก",
          })
          .then((result) => {
            if (result.isConfirmed) {
              // 🔑 ใช้ Promise.all เพื่อรอ API ทั้งหมด
              Promise.all(promises.map((p) => p.catch((e) => e)))
                .then((results) => {
                  const hasError = results.some((r) => r instanceof Error);

                  if (hasError) {
                    swalCustom.fire({
                      text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                      icon: "warning",
                      confirmButtonText: "ปิด",
                    });
                  } else {
                    swalCustom
                      .fire({
                        text: "สำเร็จ",
                        icon: "success",
                        timer: 3000,
                        confirmButtonText: "ปิด",
                      })
                      .then(() => {
                        router.replace({
                          name: "family-profile",
                          id: route.params.famid,
                        });
                      });
                  }
                })
                .catch((error) => {
                  swalCustom.fire({
                    text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                    icon: "warning",
                    confirmButtonText: "ปิด",
                  });
                  console.log(error);
                });
            }
          });
      }
    }
    function closeWizardForm() {
      emit("close-wizard", currStep.value);
    }
    function prevStep() {
      emit("prev-step", currStep.value);
    }
    function cancelModalButton() {
      validate.value.$reset();
      emit("cancelButton");
    }
    watch(
      () => props.cancelModal,
      (val) => {
        if (val) {
          Object.assign(form, formDefault);
          validate.value.$reset();
        }
      }
    );
    watch(
      () => props.openModal,
      (val) => {
        if (val) {
          const memberData = JSON.parse(JSON.stringify(props.editData));
          for (const key of dimProblemNames) {
            form.prob_summary[key] = [];
            form.tempProbSummary[key] = [];
          }
          if (
            memberData.prob_summary
              ? Object.keys(memberData.prob_summary)?.length > 0
              : false
          ) {
            Object.assign(form.prob_summary, memberData.prob_summary);
            for (const key of dimProblemNames) {
              form.tempProbSummary[key] =
                structuredClone(memberData.prob_summary[key]) || [];
            }
          }

          problemNames.forEach((key) => {
            //assign prob to each key prob
            form.problemObj[key] =
              memberData[key]?.length > 0 ? memberData[key] : [];
            //find index with name == key of data_problem
            let idx_data = data_problem.findIndex((x) => x.name == key);
            form.problemObj[key].forEach((item) => {
              //get index of choice option
              let idx_choice = data_problem[idx_data].choices.findIndex(
                (opt) => opt.option.code == item.code
              );
              //set value to checked checkbox
              if (idx_choice != -1)
                data_problem[idx_data].choices[idx_choice].option = item;
              //get dimension that belong to this current code
              let dim_problem = dim_prob.filter(
                (x) => x.prob_code == item.code
              );
              //map item to problem summary array with correct dim of this code
              for (let elm of dim_problem) {
                //eg. this prob is in family dim
                //check in current summary with elm dim has this code yet or not
                let check_idx = form.prob_summary[elm.dim_code].findIndex(
                  (x) => x.code == elm.prob_code
                );
                //not in correct dim or not dim yet
                if (check_idx == -1) {
                  //map problem incorrect dim. or problem not group with dim to current prob_summary with a correct dim
                  form.prob_summary[elm.dim_code] = [
                    ...form.prob_summary[elm.dim_code],
                    { ...item, status: 0 },
                  ];
                  //if already has prob_summary then check each problem group with correct dim
                  if (memberData.prob_summary) {
                    //for loop check each key in old prob_summary to check each problem map with correct dim
                    Object.keys(memberData.prob_summary).forEach((prob_key) => {
                      //find index of current prob_code of each key in current prob_summary
                      let prob_key_idx = form.prob_summary[prob_key].findIndex(
                        (x) => x.code == elm.prob_code
                      );
                      //found if dim not match (incorrect dim) then push the value to current prob_summary and remove from incorrect dim.
                      if (prob_key_idx != -1 && elm.dim_code != prob_key) {
                        //get index of this code from current summary and current dim. to prevent duplicate code
                        let cur_idx = form.prob_summary[elm.dim_code].findIndex(
                          (x) => x.code == elm.prob_code
                        );
                        //always have value
                        if (cur_idx) {
                          //remove form current summary with current dim
                          form.prob_summary[elm.dim_code].splice(cur_idx, 1);
                          //map value from old dim to prob_summary new dim and then remove from the old dim
                          form.prob_summary[elm.dim_code] = [
                            ...form.prob_summary[elm.dim_code],
                            form.prob_summary[prob_key][prob_key_idx],
                          ];
                          form.prob_summary[prob_key].splice(prob_key_idx, 1);
                        }
                      }
                    });
                  }
                }
              }
            });
          });
        }
      }
    );
    const checkedChange = (val) => {
      let dim_problem = dim_prob.filter(
        (x) => x.prob_code == val.target._value.code
      );
      for (let elm of dim_problem) {
        let check_idx = form.prob_summary[elm.dim_code].findIndex(
          (x) => x.code == elm.prob_code
        );
        if (check_idx == -1 && val.target.checked) {
          //inside if tempData in case edit then unchecked and checked again use the old value
          let tempData = form.tempProbSummary[elm.dim_code].find(
            (item) => item.code == val.target._value.code
          );
          if (tempData) {
            form.prob_summary[elm.dim_code] = [
              ...form.prob_summary[elm.dim_code],
              tempData,
            ];
          } else {
            form.prob_summary[elm.dim_code] = [
              ...form.prob_summary[elm.dim_code],
              { ...val.target._value, status: 0 },
            ];
          }
        } else {
          //unchecked then remove from array
          form.prob_summary[elm.dim_code].splice(check_idx, 1);
        }
      }
    };
    const dealWithUncheckedChoices = async () => {
      const memberData = structuredClone(props.editData);
      const setOfOriginalCode = new Set(); // problem code ของตัวเลือกที่ถูกเลือกเริ่มแรก (ก่อน user จะ check/uncheck ตัวเลือก)
      const setOfCurrentCode = new Set(); // problem code ของตัวเลือกที่ถูกเลือกก่อน user จะกดบันทึก

      for (const key of problemNames) {
        memberData[key]?.forEach((problem) =>
          setOfOriginalCode.add(problem.code)
        );
        form.problemObj[key].forEach((problem) =>
          setOfCurrentCode.add(problem.code)
        );
      }

      const setOfUncheckedCode = setOfOriginalCode.difference(setOfCurrentCode); // problem code ของตัวเลือกที่ user uncheck

      for (const uncheckedCode of setOfUncheckedCode) {
        let continueAsking = true;
        while (continueAsking) {
          await Swal.fire({
            title: `คุณกำลังจะลบปัญหา\n\n"${
              mapCodeToOptionAndDesc.get(uncheckedCode)["desc"]
            }"`,
            text: `หากคุณลบปัญหา "${
              mapCodeToOptionAndDesc.get(uncheckedCode)["desc"]
            }" แผนการให้ความช่วยเหลือที่เกี่ยวข้องจะถูกลบไปด้วย`,
            icon: "warning",
            showConfirmButton: getAllowActionByCurrRole("edit-problem-plan"),
            showDenyButton: true,
            showCancelButton: true,
            customClass: {
              confirmButton: "btn btn-outline-secondary m-1",
              denyButton: "btn btn-danger m-1",
              cancelButton: "btn btn-primary m-1",
            },
            confirmButtonText: "ยุติปัญหา",
            denyButtonText: "ลบ",
            cancelButtonText: "ยกเลิก",
            buttonsStyling: false,
          }).then(async (result) => {
            if (result.isConfirmed) {
              $(`#form-input-problem-${uncheckedCode}`).click();
              const dim_problems = dim_prob.filter(
                (problem) => problem.prob_code === uncheckedCode
              );
              const codeOfDimToBeChanged = new Set();
              for (const dim_problem of dim_problems) {
                const summaryProblemToBeChanged = form.prob_summary[
                  dim_problem.dim_code
                ].find(
                  (summary_problem) =>
                    summary_problem.code === dim_problem.prob_code
                );
                if (summaryProblemToBeChanged.status === 2) {
                  summaryProblemToBeChanged.status = 3;
                  codeOfDimToBeChanged.add(dim_problem.dim_des);
                }
              }
              if (codeOfDimToBeChanged.size === 0) {
                await swalCustom.fire({
                  text: `ไม่มีปัญหา ${mapCodeToOptionAndDesc.get(uncheckedCode)["desc"]} ที่สามารถยุติได้`,
                  icon: "error",
                });
                $(`#form-input-problem-${uncheckedCode}`).click();
              } else {
                await swalCustom.fire({
                  html: `ความช่วยเหลือปัญหา<br />${
                    mapCodeToOptionAndDesc.get(uncheckedCode)["desc"]
                  }<br />ใน${[...codeOfDimToBeChanged].join(
                    ", "
                  )} จะถูกยุติสำเร็จเมื่อกด 'ตกลง' ในหน้าต่อไป`,
                  icon: "info",
                });
                continueAsking = false;
              }
            } else if (result.isDenied) {
              // ไม่ต้องทำอะไร
              continueAsking = false;
            } else if (result.isDismissed) {
              $(`#form-input-problem-${uncheckedCode}`).click();
              continueAsking = false;
            }
          });
        }
      }
    };
    const updateUserTextInput = (inputEvent, prob_code) => {
      const dimProblems = dim_prob.filter(
        (dimProblem) => dimProblem.prob_code === prob_code
      );
      for (const dimProblem of dimProblems) {
        const targetInProbSummary = form.prob_summary[dimProblem.dim_code].find(
          (item) => item.code === prob_code
        );
        const targetInTemp = form.tempProbSummary[dimProblem.dim_code].find(
          (item) => item.code === prob_code
        );

        targetInProbSummary.name = inputEvent.target.value;
        if (targetInTemp) {
          targetInTemp.name = inputEvent.target.value;
        }
      }
    };
    return {
      form,
      completeForm,
      closeWizardForm,
      prevStep,
      validate,
      data_problem,
      cancelModalButton,
      checkedChange,
      dealWithUncheckedChoices,
      updateUserTextInput,
    };
  },
});
</script>

<style></style>
